import { render } from "./DiyDetail.vue?vue&type=template&id=4b2c0dc1&scoped=true"
import script from "./DiyDetail.vue?vue&type=script&lang=js"
export * from "./DiyDetail.vue?vue&type=script&lang=js"

import "./DiyDetail.vue?vue&type=style&index=0&id=4b2c0dc1&lang=scss&scoped=true"

import exportComponent from "/root/Fnedu/build/build20221128.131745/dashboard/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b2c0dc1"]])

export default __exports__